import type { ExtractType } from "./tables/columnConfigs/baseColumnConfig";

export type TableData<T> = { [k in keyof T]: ExtractType<T[k]> | undefined } & {
  /**
   * subComponent is used for expandable rows in tables. It's typed as `any` because the underlying
   * Magnetic Table library has strict index signature constraints that conflict with ReactElement types.
   * This allows tables to include sub-tables or expandable content without requiring type assertions
   * at every usage site.
   */
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  subComponent?: any;
};

export enum TypedTableRendererType {
  magnetic = 0,
  agGrid = 1
}
